import { PSI_OUTPUT_LABELS } from '@/helpers/unit-formatter/unit-formatter.constants';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  formatNumber,
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Formatter for BFF psig-inhg composite pressure display.
 * Display-only: no PSIG↔inHG conversion. Sign selects the unit label; magnitude is shown as-is.
 *
 * - value < 0 → abs(value) with inHG
 * - value >= 0 → value with PSIG
 */
export function formatPsigInhg(unitValue: UnitValue, _displayUnits?: string): FormattedUnitLabels {
  const value = toNumber(unitValue.value);

  if (value == null) {
    return unitValueToFormattedUnitLabels({
      value: unitValue.value,
      units: undefined,
    });
  }

  if (value < 0) {
    return unitValueToFormattedUnitLabels({
      value: formatNumber(Math.abs(value)),
      units: PSI_OUTPUT_LABELS.INHG,
    });
  }

  return unitValueToFormattedUnitLabels({
    value: formatNumber(value),
    units: PSI_OUTPUT_LABELS.PSIG,
  });
}
